import React from 'react';
import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {ArcElement, Chart as ChartJS, Legend, Tooltip} from 'chart.js';
import {useObservable} from '@ngneat/react-rxjs';

import {statisticsQuery} from '@store/statistics';

import {Colors} from '@constants/colors.constants';

import SmallStatisticsCard from '@components/statistics/cards/SmallStatistics.card';

ChartJS.register(ArcElement, Tooltip, Legend);

const TonnageChart = () => {
  const {t} = useTranslation();

  const [{evolutionOfOperations, loading}] = useObservable(statisticsQuery.evolutionOfOperations$);

  return (
    <Stack
      flex={1}
      height="300px"
      bgcolor={Colors.white}
      borderRadius="4px"
      p="20px"
      direction="row"
      justifyContent="space-between"
      spacing={8}
    >
      <Stack flex={1}>
        <Typography fontSize={18} fontWeight="700" mb="20px">
          {t('dashboard.statistics.operations.tonnage.title')}
        </Typography>
        <Stack direction="column" flex={1} spacing={2}>
          <Stack flex={1} spacing={2} direction="row">
            <Stack flex={1} spacing={2}>
              <SmallStatisticsCard
                title={t('dashboard.statistics.operations.tonnage.pickupWeight')}
                value={(evolutionOfOperations?.execPickupWeight.current || 0).toFixed(2)}
                loading={loading}
                progress={0}
                unit="t"
              />
            </Stack>
            <Stack flex={1} spacing={2}>
              <SmallStatisticsCard
                title={t('dashboard.statistics.operations.tonnage.pickupTheoWeight')}
                value={(evolutionOfOperations?.execTheoPickupWeight.current || 0).toFixed(2)}
                loading={loading}
                progress={0}
                unit="t"
              />
            </Stack>
            <Stack flex={1} spacing={2}>
              <SmallStatisticsCard
                title={t('dashboard.statistics.operations.tonnage.averageTonnagePerCollect')}
                value={(
                  (evolutionOfOperations?.execPickupWeight.current || 0) /
                  (evolutionOfOperations?.execExecutedPickupCount.current || 1)
                ).toFixed(2)}
                loading={loading}
                progress={0}
                unit="t"
              />
            </Stack>
          </Stack>
          <Stack direction="row" flex={1} spacing={2}>
            <Stack flex={1} spacing={2}>
              <SmallStatisticsCard
                title={t('dashboard.statistics.operations.tonnage.processingWeight')}
                value={(evolutionOfOperations?.execProcessingWeight.current || 0).toFixed(2)}
                loading={loading}
                progress={0}
                unit="t"
              />
            </Stack>
            <Stack flex={1} spacing={2}>
              <SmallStatisticsCard
                title={t('dashboard.statistics.operations.tonnage.valorisationWeight')}
                value={(evolutionOfOperations?.execValorisationWeight.current || 0).toFixed(2)}
                loading={loading}
                progress={0}
                unit="t"
              />
            </Stack>
          </Stack>
        </Stack>

      </Stack>
    </Stack>
  );
};

export default TonnageChart;
